module.exports = __webpack_public_path__ + "static/img/lunbo1.ae0735f8.png";